/**
 * CitationFooter — numbered source list at the bottom of the document.
 */

const CitationFooter = ({
  citations,
  onSourceClick,
  activeSourceId,
  citationInteractions,
}) => {
  if (!citations || citations.length === 0) return null;
  return (
    <div className="mt-8 pt-4 border-t border-zinc-200 dark:border-zinc-800">
      <h4 className="text-[11px] font-semibold uppercase tracking-wider text-zinc-400 dark:text-zinc-500 mb-2">
        Sources
      </h4>
      <ol className="space-y-1">
        {citations.map((c) => (
          <li key={c.index} className="flex items-baseline gap-2 text-[12px]">
            <span className="text-zinc-400 dark:text-zinc-500 font-mono shrink-0">
              [{c.index}]
            </span>
            {c.url && onSourceClick ? (
              <button
                onClick={() => onSourceClick(c)}
                className={[
                  "text-left truncate text-[12px] cursor-pointer transition-colors",
                  activeSourceId === c.url
                    ? "text-sky-500 dark:text-sky-300 font-medium"
                    : "text-sky-600 dark:text-sky-400 hover:text-sky-800 dark:hover:text-sky-300",
                ].join(" ")}
                title={c.url}
              >
                {c.title || c.url}
                {citationInteractions?.[c.url] &&
                  (citationInteractions[c.url].like ||
                    citationInteractions[c.url].dislike ||
                    citationInteractions[c.url].catalog) && (
                    <span className="inline-flex items-center gap-px ml-1.5">
                      {citationInteractions[c.url].like && (
                        <span className="inline-block w-[7px] h-[7px] rounded-full bg-emerald-400" />
                      )}
                      {citationInteractions[c.url].dislike && (
                        <span className="inline-block w-[7px] h-[7px] rounded-full bg-red-400" />
                      )}
                      {citationInteractions[c.url].catalog && (
                        <span className="inline-block w-[7px] h-[7px] rounded-full bg-amber-400" />
                      )}
                    </span>
                  )}
              </button>
            ) : (
              <span className="text-zinc-600 dark:text-zinc-400">
                {c.title || `Source ${c.index}`}
              </span>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
};

export default CitationFooter;
